<template>
  <div>
    <b-form @submit.prevent="submit" novalidate>
      <div class="row">
        <div class="col-12">

          <validated-form-input name="amount" :label="name + ':'" placeholder="Maksu summa"
                                v-model="tax.amount" :autofocus="true" validate="required|decimal|min_value:0" :validator="$validator"/>

        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <submit-button class="float-right" variant="primary">Salvesta</submit-button>
        </div>
      </div>
    </b-form>
  </div>

</template>

<script>
  import ValidatedFormInput from '../ValidatedFormInput'

  export default {
    props: ['data'],
    components: {ValidatedFormInput},
    data() {
      return {
        name: this.data.name,
        tax: Object.assign({
          amount: null,
          groupName: null,
          declarationId: null,
          invoiceId: null
        }, this.data)
      }
    },
    methods: {
      submit() {
        this.$validator.validateAll().then((valid) => {
          if (!valid) return
          this.$gateway.post(`/invoices/${this.tax.invoiceId}/update-tax-amount`, this.tax)
            .then(() => {
              this.$notifications.info('Summa on muudetud')
              this.$emit('done')
            })
            .catch(r => {
              this.$notifications.error(r.response.data.key ? this.$t(r.response.data.key) : 'Salvestamine ebaõnnestus')
            })
        })
      },
    }
  }
</script>
